import React from 'react';
import PropTypes from 'prop-types';
import quiz from '../../content/quiz.json';

const Question = props => {
  const { number, onAnswerClicked } = props;
  const question = quiz[number - 1];
  const answerName = `answer-${number}`;
  const nextAnswerName = `answer-${number + 1}`;
  return (
    <div className="container">
      <div className="question row">
        <div className="col-md-7">
          <p>{question.text}</p>
        </div>
        <div className="col-md-offset-1 col-md-4" id={answerName}>
          {question.answers.map((answer, index) =>
            <div className="radio" key={`${answerName}-${index}`}>
              <input
                id={`${answerName}-${index}`}
                type="radio"
                name={answerName}
                value={answer.value}
                required
                onClick={() => onAnswerClicked(answerName, index, answer.value, nextAnswerName)}
              />
              <label htmlFor={`${answerName}-${index}`}>{answer.text}</label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Question.propTypes = {
  number: PropTypes.number.isRequired,
  onAnswerClicked: PropTypes.func.isRequired
};

Question.defaultProps = {};

export default Question;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/components/Question/Question.js